"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createCustomEvent;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

function createCustomEvent(name, eventInitDict) {
  if (name === 'error') {
    if (typeof ErrorEvent === 'function') {
      return new ErrorEvent(name, eventInitDict);
    }
  } else if (typeof CustomEvent === 'function') {
    return new CustomEvent(name, eventInitDict);
  }

  var event = document.createEvent('Event');
  event.initEvent(name, true, true);
  Object.entries(eventInitDict || {}).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    event[key] = value;
  });
  return event;
}